@if (isScheduledPermission) {
<button type="button" mat-icon-button class="open-button mat-primary-bg mat-elevation-z2" (click)="openBar()">
  <mat-icon>edit_calendar</mat-icon>
</button>
}

<div #overlay class="table-options-panel-overlay" [fxHide]="isBarClosed" [@fadeInOut]="!isBarClosed"></div>

<div #panel class="table-options-panel mat-elevation-z8">
  <span class="title">{{ 'CONFIGURATION.SCHEDULED_REPORTS_TITLE' | translate }}</span>
  <button type="button" mat-icon-button class="close-button" (click)="closeBar()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <div class="table-options-panel-inner" fxLayout="column" fxLayoutAlign="start stretch">
    <div class="mt-12 mb-12">
      @if (isAddMode) {
      <button type="button" class="mt-sm-0" mat-stroked-button color="accent" (click)="handleAddNewSchedule()">
        {{ 'BUTTONS.CREATE_NEW' | translate }}
      </button>
      }
    </div>

    <h2>{{ 'CONFIGURATION.SCHEDULED_REPORTS_TITLE' | translate }}:</h2>
    <div class="scheduled-list">
      <div class="scheduled-list-header">{{ 'FIELDS.title' | translate }}</div>
      <mat-divider></mat-divider>
      <lin-progress-bar [isShown]="isLoading$ | async"></lin-progress-bar>
      @if (!scheduledReportList?.length) {
      <div class="scheduled-list-empty">{{ 'CONFIGURATION.SCHEDULED_REPORTS.NO_REPORTS' | translate }}</div>
      } @for (report of scheduledReportList; track report.id) {
      <div class="scheduled-list-item">
        <div class="scheduled-list-item-name">{{ report.name }}</div>
        <div class="scheduled-list-item-actions">
          @if (isEditMode) {
          <button mat-icon-button (click)="handleEdit(report)" [matTooltip]="'CONFIGURATION.SCHEDULED_REPORTS.EDIT' | translate">
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
          }
          <button mat-icon-button (click)="handlePreview(report)" [matTooltip]="'CONFIGURATION.SCHEDULED_REPORTS.VIEW' | translate">
            <mat-icon svgIcon="list_alt"></mat-icon>
          </button>
          @if (isEditMode) {
          <button mat-icon-button (click)="handleUpdate(report)" [matTooltip]="'CONFIGURATION.SCHEDULED_REPORTS.UPDATE' | translate">
            <mat-icon>system_update_alt</mat-icon>
          </button>
          } @if (isDeleteMode) {
          <button
            mat-icon-button
            type="button"
            (click)="handleDelete(report.id)"
            [matTooltip]="'CONFIGURATION.SCHEDULED_REPORTS.DELETE' | translate"
          >
            <mat-icon svgIcon="delete"></mat-icon>
          </button>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>
